import { SortDescriptor } from "react-aria-components";

import { ManagedUserGroupIntegration } from "types/generated";

import { SLACK_COLUMN_ID } from "../components/Table/constants";

export const sortIntegrations = (
  items: ManagedUserGroupIntegration[],
  sortDescriptor: SortDescriptor
) => {
  if (!sortDescriptor.column) {
    return items;
  }

  const isAscending = sortDescriptor.direction === "ascending";

  return [...items].sort((a, b) => {
    let valueA: string | number | undefined;
    let valueB: string | number | undefined;

    // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check
    switch (sortDescriptor.column as SLACK_COLUMN_ID) {
      case SLACK_COLUMN_ID.NAME:
        valueA = a.integrationName;
        valueB = b.integrationName;
        break;
      case SLACK_COLUMN_ID.SPACES:
        valueA = a.accessRules?.length ?? 0;
        valueB = b.accessRules?.length ?? 0;
        break;
    }

    if (typeof valueA === "number" && typeof valueB === "number") {
      return isAscending ? valueA - valueB : valueB - valueA;
    }

    const stringA = String(valueA ?? "");
    const stringB = String(valueB ?? "");

    return isAscending ? stringA.localeCompare(stringB) : stringB.localeCompare(stringA);
  });
};
